import 'whatwg-fetch';
import qs from 'querystring';
import { message } from 'antd';
import history from '@/utils/history';
type RequestOptions = {
  body?: string;
};
class Request {
  static baseUrl = '';
  static request(path: string, method: string, param: Record<string, any> = {}, options: RequestOptions = {}) {
    const pre = process.env.netPre;
    const url = `${Request.baseUrl}${pre}${path}`;
    const targetOption: any = {
      ...options,
      method,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json '
      }
    };
    if (param && method !== 'GET') {
      if (param instanceof FormData) {
        console.log('param====', param.get('upload_file'));
        targetOption.body = param;
        delete targetOption.headers['Content-Type'];
      } else {
        targetOption.body = JSON.stringify(param);
      }
    }
    return fetch(url, {
      ...targetOption
    })
      .then(async (res) => {
        const resJson: any = await res.json();
        console.log('resJson====', resJson);
        if (resJson.errno != 0 && resJson.errno != 30000) {
          message.warning(resJson.error);
        } else if (resJson.errno === 30000) {
          history.push('/login');
        }
        return resJson;
      })
      .catch((err) => {
        console.log('err===', err);
      });
  }
  static get(path: string, param?: Record<string, any>, options?: RequestOptions) {
    return Request.request(path, 'GET', param, options);
  }
  static post(path: string, param: Record<string, any>, options?: RequestOptions) {
    return Request.request(path, 'POST', param, options);
  }
}
export default Request;
